import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { EmailUserConfigModel } from '@smarttask-common/src/lib/models/Integrations/Email/Config/EmailUserConfigModel';

export enum EmailUserConfigActionTypes {
    ADD_EMAIL_USER_CONFIG = '[EmailUserConfig] Create EmailUserConfig',
    ADD_EMAIL_USER_CONFIGS = '[EmailUserConfig] Add EmailUserConfigs',
    UPSERT_EMAIL_USER_CONFIG = '[EmailUserConfig] Upsert EmailUserConfig',
    UPSERT_EMAIL_USER_CONFIGS = '[EmailUserConfig] Upsert EmailUserConfigs',
    UPDATE_EMAIL_USER_CONFIG = '[EmailUserConfig] Update EmailUserConfig',
    UPDATE_EMAIL_USER_CONFIGS = '[EmailUserConfig] Update EmailUserConfigs',
    DELETE_EMAIL_USER_CONFIG = '[EmailUserConfig] Delete EmailUserConfig',
    DELETE_EMAIL_USER_CONFIGS = '[EmailUserConfig] Delete EmailUserConfigs',
    DELETE_ALL_EMAIL_USER_CONFIGS = '[EmailUserConfig] Delete All EmailUserConfigs',
    DELETE_ALL = '[EmailUserConfig] Delete All',

    UPDATE_SELECTED_ID = '[EmailUserConfig] Update SelectedId',
}

export class UpdateSelectedConfigId implements Action {
    readonly type = EmailUserConfigActionTypes.UPDATE_SELECTED_ID;
    constructor(public selected_config_id: number) {}
}

export class AddOne implements Action {
    readonly type = EmailUserConfigActionTypes.ADD_EMAIL_USER_CONFIG;
    constructor(public config: EmailUserConfigModel) {}
}

export class AddMany implements Action {
    readonly type = EmailUserConfigActionTypes.ADD_EMAIL_USER_CONFIGS;
    constructor(public configs: Array<EmailUserConfigModel>) {}
}

export class UpsertOne implements Action {
    readonly type = EmailUserConfigActionTypes.UPSERT_EMAIL_USER_CONFIG;

    constructor(public config: EmailUserConfigModel) {}
}

export class UpsertMany implements Action {
    readonly type = EmailUserConfigActionTypes.UPSERT_EMAIL_USER_CONFIGS;
    constructor(public configs: Array<EmailUserConfigModel>) {}
}

export class UpdateOne implements Action {
    readonly type = EmailUserConfigActionTypes.UPDATE_EMAIL_USER_CONFIG;
    constructor(public config: Update<EmailUserConfigModel>) {}
}

export class UpdateMany implements Action {
    readonly type = EmailUserConfigActionTypes.UPDATE_EMAIL_USER_CONFIGS;
    constructor(public configs: Array<Update<EmailUserConfigModel>>) {}
}

export class DeleteOne implements Action {
    readonly type = EmailUserConfigActionTypes.DELETE_EMAIL_USER_CONFIG;
    constructor(public config_id: number) {}
}

export class DeleteMany implements Action {
    readonly type = EmailUserConfigActionTypes.DELETE_EMAIL_USER_CONFIGS;
    constructor(public config_ids: Array<number>) {}
}

export class DeleteAll implements Action {
    readonly type = EmailUserConfigActionTypes.DELETE_ALL_EMAIL_USER_CONFIGS;
    constructor(public config_ids: Array<number>) {}
}

export class DeleteState implements Action {
    readonly type = EmailUserConfigActionTypes.DELETE_ALL;
    constructor() {}
}

export type EmailUserConfigActions =
    | AddOne
    | AddMany
    | UpsertOne
    | UpsertMany
    | DeleteOne
    | DeleteMany
    | DeleteAll
    | DeleteState
    | UpdateOne
    | UpdateMany
    | UpdateSelectedConfigId;
